import React, { } from 'react';
import { useTranslation } from 'react-i18next';
import { wrapper } from '../../reports/styles/style';
import OrderDetailTxt from '../../orders/components/forms/edditOrder/OrderDetailTxt';
import { translateOrderTypeName } from '../../common/enums/orderTypes.enum';

interface IContainerShowForm {
    initValues: any
}

const ContainerShowForm: React.FC<IContainerShowForm> = ({ initValues }) => {
    const { t } = useTranslation("admin");

    return (
        <div className={wrapper}>
            <div>
                <OrderDetailTxt
                    title={t("nav.containerNumber") as string}
                    value={initValues.ContainerNumber}
                />
                <OrderDetailTxt
                    title={t("nav.panelContainerStatus") as string}
                    value={t(`containers.status.${initValues.status}`, { defaultValue: t('containers.status.default') }) as string}
                />
                {/* <OrderDetailTxt
                    title="Kod QR / Identyfikator kontenera"
                    value={initValues.identifier}
                /> */}
                <OrderDetailTxt
                    title={t("nav.iccidNumber") as string}
                    value={initValues.iccid}
                />
                <OrderDetailTxt
                    title={t("nav.imeiNumber") as string}
                    value={initValues.imei}
                />
                <OrderDetailTxt
                    title={t("nav.serialNumber") as string}
                    value={initValues.serNo}
                />
                <OrderDetailTxt
                    title={t("nav.containerNumber") as string}
                    value={initValues.containerNumber}
                />
                <OrderDetailTxt
                    title={t("nav.containerDesc") as string}
                    value={initValues.description}
                />
                {/* <OrderDetailTxt
                    title="Kod UHF bramki"
                    value={initValues.uhfIdentifier}
                /> */}
                <OrderDetailTxt
                    title={t("nav.batteryLevel") as string}
                    value={initValues.currentBatteryLevel}
                />
                <OrderDetailTxt
                    title={t("nav.lastActivity") as string}
                    value={initValues.lastActiveDate}
                />
                <OrderDetailTxt
                    title={t("nav.latitude") as string}
                    value={initValues.latitude}
                />
                <OrderDetailTxt
                    title={t("nav.longitude") as string}
                    value={initValues.longitude}
                />
                <OrderDetailTxt
                    title={t("nav.closestReceptionPlaceType") as string}
                    value={translateOrderTypeName(initValues.closestReceptionPlaceType, t)}
                />
                <OrderDetailTxt
                    title={t("nav.closestReceptionPlaceAddress") as string}
                    value={initValues.closestReceptionPlaceAddress}
                />
                <OrderDetailTxt
                    title={t("nav.closestReceptionPlaceDistance") as string}
                    value={initValues.closestReceptionPlaceDistance}
                />
                <OrderDetailTxt
                    title={t("nav.closestCompanyName") as string}
                    value={initValues.closestCompanyName}
                />
                <OrderDetailTxt
                    title={t("nav.closestCompanyTaxNumber") as string}
                    value={initValues.closestCompanyTaxNumber}
                />
            </div>
        </div>
    )
};

export default ContainerShowForm;